import React, { Component } from "react";
import { Anchor, Box, Heading, Main, Paragraph } from "grommet";
import StyledLink from "./StyledLink";

class HomePage extends Component {
  render() {
    return (
      <Main direction="row" flex overflow={{ horizontal: "hidden" }}>
        <Box flex align="center" justify="center" pad="small">
          <Heading level="3" margin={{ bottom: "xsmall" }}>
            Hi, I'm Rafael.
          </Heading>
          <Box flex overflow="auto">
            <Paragraph textAlign="center">
              I am a computer scientist. I received my B.Sc. from{" "}
              <Anchor href="https://cc.gatech.edu" target="_blank">
                Georgia Tech
              </Anchor>{" "}
              in 2020. My professional interests are data science, full-stack
              web development, and networks.
            </Paragraph>

            <Paragraph textAlign="center">
              <Anchor
                href={`${process.env.PUBLIC_URL}/Resume.pdf`}
                target="_blank"
              >
                Here's my resume
              </Anchor>
              , along with{" "}
              <StyledLink to="/projects">projects and experiments</StyledLink>.
              You may contact me via{" "}
              <Anchor href="https://linkedin.com/in/rpaulucci" target="_blank">
                LinkedIn
              </Anchor>
              .
            </Paragraph>
          </Box>
        </Box>
      </Main>
    );
  }
}

export default HomePage;
